<template>
    <div class="form-input form-input-checkbox">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field form-input-field--line">
            <div class="checkbox-option option">
                <label class="form-input-radio-label" :class="value === option.value ? 'bold' : ''">
                    <input type="checkbox" :value="option.value" v-model="checkboxValue" />
                    <span></span>
                    {{ option.title }}
                </label>
            </div>
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputCheckbox',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        option: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
    },
    computed: {
        checkboxValue: {
            get() { return this.value; },
            set(newValue) {
                this.$emit('input', newValue);
            },
        },
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
    },
};
</script>
